import { createFileRoute } from "@tanstack/react-router";
import { AngebotsVorlageSeite } from "@/pages/team/AngebotsVorlageSeite";

/** Eine Angebotsvorlage bearbeiten (Angebotstool, 12.09.2026) — Inhaber-Sache, Formular + Vorschau. */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/angebotsvorlagen/$vorlageId")({
	component: VorlageSeite,
});

function VorlageSeite() {
	const { vorlageId } = Route.useParams();
	return <AngebotsVorlageSeite vorlageId={vorlageId} />;
}
